import React, { useState, useEffect, useContext } from "react";
import { useLazyQuery } from "@apollo/react-hooks";
import Queries from "../Queries";
import { GlobalContext } from "./../Context";
import "./AdvanceFilters.scss";

function AdvanceFilters({ data, advanceFiltersVisibility, filterState }) {
  const globalContext = useContext(GlobalContext);
  const {
    langcode,
    positionState,
    initialPos,
    setAdvancedFiltersVisibility,
    radius,
    geolocationState,
    mapsInstance,
    setBranches,
    setResultsState,
    setMarkersVisibility,
    setFiltersVisibility,
    setCurrentPopUp,
    activeFilters,
    addActiveFilter,
    setBranchSchedulesVisibility
  } = globalContext;
  const [tids, setTids] = useState("");
  const [isButtonClicked, setIsButtonClicked] = useState("");
  const [queryState, setQueryState] = useState("waiting");
  const [getBranches, queryResult] = useLazyQuery(Queries("branches"), {
    variables: {
      langcode: langcode,
      tids: tids,
      field_coordinates_proximity: `${initialPos.lat},${initialPos.lng}<${
        radius / 1000
      }km`,
    },
  });

  useEffect(() => {
    if (activeFilters) {
      setTids(activeFilters.join("+"));
    }
  }, [activeFilters]);

  useEffect(() => {
    if (queryResult.data && mapsInstance && isButtonClicked) {
      let { google } = mapsInstance;
      let queryCircle = new google.maps.Circle({
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        center: new google.maps.LatLng(initialPos),
        radius: radius,
      });
      let markers = [];
      queryResult.data.officeBranchesQuery.results.forEach((item) => {
        let location = new google.maps.LatLng({
          lat: item.fieldCoordinates.lat,
          lng: item.fieldCoordinates.lng,
        });
        let marker = new google.maps.Marker({
          position: location,
        });
        if (
          google.maps.geometry.spherical.computeDistanceBetween(
            marker.getPosition(),
            queryCircle.getCenter()
          ) <= queryCircle.getRadius()
        ) {
          markers.push(item);
        }
      });

      if (markers.length > 0) {
        setQueryState("success");
        setBranches(markers);
        setAdvancedFiltersVisibility(false);
        setBranchSchedulesVisibility(false);
        setFiltersVisibility(false);
        setResultsState(true);
        setMarkersVisibility(true);
        setCurrentPopUp(false);
      } else {
        setQueryState("fails");
      }
      setIsButtonClicked(false);
    }
  }, [
    queryResult,
    mapsInstance,
    isButtonClicked,
    initialPos,
    radius,
    setBranches,
    setFiltersVisibility,
    setResultsState,
    setMarkersVisibility,
    setCurrentPopUp,
    setAdvancedFiltersVisibility,
    setBranchSchedulesVisibility
  ]);

  switch (filterState) {
    case "loading":
      return (
        <h2 className="filter-message filter-message--loading">Cargando...</h2>
      );
    case "error":
      return (
        <h2 className="filter-message filter-message--error">
          Ha ocurrido un error, por favor inténtelo de nuevo más tarde
        </h2>
      );
    case "ready":
      if (
        data &&
        data.filtersByCountry.results[0] &&
        data.filtersByCountry.results[0].fieldAdvancedFilters.length
      ) {
        const dataDefined =
          data.filtersByCountry.results[0].fieldAdvancedFilters;
        return (
          <div
            className={`advance-filters ${
              advanceFiltersVisibility ? "show" : ""
            }`}
          >
            <div className="advance-filters-content">
              <p className="title">¿Cuál servicio requiere?</p>
              <div className="advance-filters__content">
                {dataDefined.map((group, index) => {
                  return (
                    <div key={index}>
                      <div className="advance-filters-title-container">
                        <img
                          className="advance-filters-title-image"
                          src="/modules/custom/bac_locations/js/src/assets/img/sucursal.svg"
                          alt="Filter Title"
                        />
                        <h4 className="title">{group.entity.fieldGroupType}</h4>
                      </div>
                      <div
                        className="advance-filters__group"
                        key={`advance-filter-${index}`}
                      >
                        {group.entity.fieldOptionsType.map((checkbox) => {
                          let entityLabel = checkbox.entity.entityLabel;
                          let description = checkbox.entity.description.value;
                          let id = checkbox.entity.tid;

                          return (
                            <div
                              className="advance-filters__checkbox-wrapper"
                              key={`advance-filter-${id}`}
                            >
                              <input
                                aria-labelledby={`${entityLabel} label`}
                                id={`advance-filter-${id}`}
                                className="advance-filters__checkbox"
                                type="checkbox"
                                name={`${entityLabel}`}
                                value={`${id}`}
                                checked={activeFilters.includes(`${id}`)}
                                onChange={(e) => {
                                  addActiveFilter(e.target.value);
                                }}
                              ></input>
                              {description ? (
                                <label
                                  className="label process-filter-label process-filter-label-description"
                                  htmlFor={`advance-filter-${id}`}
                                >
                                  <div className="process-filter-container">
                                    <div className="process-filter-label-title">
                                      {entityLabel}
                                    </div>
                                    <div
                                      className="process-filter-label-description"
                                      dangerouslySetInnerHTML={{
                                        __html: description,
                                      }}
                                    ></div>
                                  </div>
                                </label>
                              ) : (
                                <label
                                  className="label process-filter-label"
                                  htmlFor={`advance-filter-${id}`}
                                >
                                  <p className="process-filter-container">{`${entityLabel}`}</p>
                                </label>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="advance-filters__actions">
                <div className="advance-filters__actions-container">
                  <div>
                    <button
                      className={`advance-filters__close ${
                        queryResult.loading
                          ? "advance-filters__close--loading"
                          : ""
                      } ${
                        positionState === "loading" ||
                        geolocationState === "loading"
                          ? "advance-filters__close--disabled"
                          : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        setAdvancedFiltersVisibility(false);
                      }}
                    >
                      Cerrar
                    </button>
                  </div>
                  <div>
                    <button
                      className={`advance-filters__submit ${
                        queryResult.loading
                          ? "advance-filters__submit--loading"
                          : ""
                      } ${
                        positionState === "loading" ||
                        geolocationState === "loading"
                          ? "advance-filters__submit--disabled"
                          : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        if (
                          positionState === "success" ||
                          positionState === "failed"
                        ) {
                          setIsButtonClicked(true);
                          getBranches();
                        }
                      }}
                    >
                      Filtrar
                    </button>
                  </div>
                </div>
              </div>
              {positionState === "loading" || geolocationState === "loading" ? (
                <span className="place-search__submit-help-text place-search__submit-help-text--loading">
                  Obteniendo ubicación, por favor espere
                </span>
              ) : null}
              {!(queryState === "waiting" || queryState === "success") && (
                <p className="place-search__submit-help-text place-search__submit-help-text--error">
                  No se han podido encontrar resultados, por favor modifique su
                  búsqueda o ingrese una ubicación diferente.
                </p>
              )}
            </div>
          </div>
        );
      } else {
        return null;
      }
  }
}

export default AdvanceFilters;
